// extracted by mini-css-extract-plugin
export default {"Wrapper":"ProductsPage_Wrapper__or2hf","selectedCategory":"ProductsPage_selectedCategory__TkvHd"};